<template>
  <b-card :title="$t('Dates')">

    <b-row>
      <b-col cols="12">
        <field-date
            :model.sync="startLocal"
            name="start"
            :is-required="true"
        />
      </b-col>
      <b-col cols="12">
        <field-date
            :model.sync="endLocal"
            name="end"
            :min-date="startLocal"
            :is-required="true"
        />
      </b-col>
      <b-col cols="12">
        <field-select
            :model.sync="employeesLocal"
            :name="'employee'"
            :options="autocompleteUsers"
            :multiple="true"
        />
      </b-col>
    </b-row>
  </b-card>

</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import moment from 'moment'
import FieldDate from '../../../../components/input/Date'
import SwitchInput from '../../../../components/input/Switch'
import FieldSelect from '../../../../components/input/Select2.vue'
import useAPI from '../../../../utils/useAPI'

export default {
  components: {
    FieldDate,
    SwitchInput,
    FieldSelect
  },
  props: {
    start: {},
    end: {},
    employees: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const startLocal = ref(props.start)
    const endLocal = ref(props.end)
    const employeesLocal = ref(props.employees)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const {autocompleteUsers} = useAPI()

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(startLocal, val => {
      emit('update:start', moment(val).format('YYYY-MM-DD'))
    })
    watch(endLocal, val => {
      emit('update:end', moment(val).format('YYYY-MM-DD'))
    })
    watch(employeesLocal, val => {
      emit('update:employees', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data
      startLocal,
      endLocal,
      employeesLocal,

      // Computed
      autocompleteUsers,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>